module.exports = __webpack_public_path__ + "static/media/All Animal Video Version 1.c3c338e6.webm";